"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 上市公司综合回报指标 个股
 */
require("../../src/modules/singlestocktop/web");
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var webconfig = require("../../config/web.js");
var base_1 = __importDefault(require("./base"));
var ktype, kchart;
init();
loadchart(ktype);
loaddata();
//事件配置
loadevent();
function init() {
    ktype = '101';
    kchart = new emcharts3.k2({
        container: "#emchartk",
        width: 1065,
        height: 600,
        padding: {
            top: 0,
            bottom: 0
        },
        scale: {
            pillar: 60,
            min: 10
        },
        show: {
            fold: true
        },
        color: {
            background: "transparent"
        },
        popWin: { type: "move" },
        maxin: {
            //show: true,
            lineWidth: 30,
            skewx: 0,
            skewy: 0,
        },
        onComplete: function () {
            //$("#emchartk").remove('.loading');
        },
        onFold: function (display, type) {
            if (display === 'block') {
                $('#cyq-btn').hide();
            }
            else {
                $('#cyq-btn').show();
            }
        },
        onError: function (e) {
            console.error(e);
        }
    });
}
function loadevent() {
    $("#scale-plus").click(function () {
        kchart.shorten();
    });
    $("#scale-minus").click(function () {
        kchart.elongate();
    });
    $('#changektab span').click(function () {
        $('#changektab span').removeClass('on');
        $(this).addClass('on');
        loadchart($(this).data('value'));
    });
}
function loadchart(type) {
    $.ajax({
        url: webconfig.getWebPath("quotehisurl") + "api/qt/stock/kline/get",
        type: "GET",
        dataType: "jsonp",
        jsonp: "cb",
        data: {
            fields1: "f1,f2,f3,f4,f5,f6",
            fields2: "f51,f52,f53,f54,f55,f56,f57,f58,f59,f60,f61",
            ut: "b2884a393a59ad64002292a3e90d46a5",
            klt: type,
            fqt: 0,
            secid: stockInfo.hqCode,
            beg: 0,
            end: 20500000,
        },
        complete: function () {
            kchart.stop();
        }
    }).then(function (json) {
        if (json.rc == 0 && json.data) {
            var data = json.data;
            var yc = "1";
            var ycindex = data.klines.length - 2;
            if (data.klines.length == 1) {
                ycindex = 0;
            }
            if (data.klines.length > 0) {
                yc = data.klines[ycindex].split(",")[2];
            }
            var kdata = {
                name: data.name,
                code: data.code,
                info: {
                    yc: yc,
                    mk: data.market == 0 ? "2" : 1,
                },
                data: [],
            };
            var dates_1 = {};
            kdata.data = data.klines.map(function (v) {
                var temparray = v.split(",");
                var backarray = [
                    temparray[0],
                    temparray[1],
                    temparray[2],
                    temparray[3],
                    temparray[4],
                    temparray[5],
                    temparray[6],
                    temparray[7] + "%",
                    temparray[10],
                    temparray[8],
                    temparray[9],
                ];
                dates_1[temparray[0]] = 1;
                return backarray.join(",");
            });
            kchart.setData({ k: kdata });
            kchart.draw();
        }
    });
}
function loaddata() {
    $.ajax({
        //url: '/zhhb/api/mainInfo/'+stockInfo.code,
        url: 'https://roi.eastmoney.com/inverstorapi/query2/mainInfo?stockCode=' + stockInfo.code,
        type: "GET",
        dataType: "jsonp",
    })
        .then(function (json) {
        var info = json.data[0];
        $("td[data-field]").each(function () {
            var ele = $(this);
            var key = ele.data("field");
            var f = base_1["default"].columns[key];
            var html = '-';
            if (key == "industryName") {
                html = info.industryName;
            }
            if (key == "securityName") {
                html = "<a href='/stockdata/" + info.securityCode + ".html'>" + info.securityName + "</a>";
            }
            else if (f) {
                if (typeof f == "function") {
                    html = f(info[key], info);
                }
                else if (typeof f == "string") {
                    html = window["emfield"][f.replace('emfield.', '')](info[key], info);
                }
                else if (typeof f.formatter == "function") {
                    html = f.formatter(info[key], info);
                }
                else {
                    html = fieldtools_1["default"].fieldfmt(info[key], f.formatter);
                }
            }
            else {
                html = info[key];
            }
            ele.html(html);
        });
    });
}
